import React from 'react';
import MypageSecessionContainer from 'containers/MypageSecessionContainer/MypageSecessionContainer';

export default function MypageSecessionPage() {
    return (
        <MypageSecessionContainer />
    )
}
